// Estado global del panel (Zustand). Los componentes se suscriben solo a lo que pintan (regla e).
import { create } from 'zustand';
import { api, ApiError, type PublicConfig, type Site, type User } from './api.ts';
import { t } from './i18n/index.ts';

interface Toast {
  id: number;
  text: string;
  error: boolean;
}

interface State {
  me: User | null;
  booted: boolean;
  config: PublicConfig | null;
  sites: Site[];
  sitesLoaded: boolean;
  toast: Toast | null;
  boot: () => Promise<void>;
  setMe: (u: User | null) => void;
  loadSites: () => Promise<void>;
  putSite: (s: Site) => void;
  dropSite: (id: string) => void;
  notify: (text: string, error?: boolean) => void;
}

let toastSeq = 0;

export const useApp = create<State>((set, get) => ({
  me: null,
  booted: false,
  config: null,
  sites: [],
  sitesLoaded: false,
  toast: null,
  async boot() {
    const config = await api.config().catch(() => null);
    const me = await api.me().then((r) => r.user).catch(() => null);
    set({ config, me, booted: true });
  },
  setMe: (me) => set({ me, ...(me ? {} : { sites: [], sitesLoaded: false }) }),
  async loadSites() {
    const { sites } = await api.sites();
    set({ sites, sitesLoaded: true });
  },
  putSite: (s) => set({ sites: [s, ...get().sites.filter((x) => x.id !== s.id)].sort((a, b) => b.updatedAt - a.updatedAt) }),
  dropSite: (id) => set({ sites: get().sites.filter((x) => x.id !== id) }),
  notify(text, error = false) {
    const id = ++toastSeq;
    set({ toast: { id, text, error } });
    setTimeout(() => {
      if (get().toast?.id === id) set({ toast: null });
    }, error ? 6000 : 3000);
  },
}));

// Mensaje legible de un error del API (códigos en errors.* de en.json).
export function errorText(e: unknown): string {
  if (e instanceof ApiError) {
    const key = `errors.${e.code}`;
    const s = t(key);
    return s === key ? t('errors.generic', { code: e.code }) : s;
  }
  return t('errors.network');
}
